/**
/**
 * Created by orojo on 14/06/2018.
 */

import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
// import * as XLSXStyle from 'xlsx-style';
import {CellObject} from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }
   /**
   * Genera un archivo de excel .XLSX con un encabezado principal y títulos de columnas.
   * @param encabezado un json con el formato: «[["Employee Details"], ["Emp Name", "Emp Sal"]]»
   *
   * @param datos un json con formato que corresponda con
   * el parámetro «encabezado», ejemplo: «[{name:"xyz", sal:1000},{name:"abc", sal:2000}]»
   * @param nombreArchivo - string con el nombre del archivo sin extensión.
   */
  public exportarComoXlsxConEncabezado(encabezado: any[], datos: any[], nombreArchivo: string): void {
    const workSheet = XLSX.utils.aoa_to_sheet(encabezado);
    XLSX.utils.sheet_add_json(workSheet, datos, {
      header: encabezado.slice(-1)[0],
      skipHeader: true,
      origin: encabezado.length
    });
    const workbook: XLSX.WorkBook = { Sheets: { 'Hoja 1': workSheet }, SheetNames: ['Hoja 1'] };
    // Use XLSXStyle instead of XLSX write function which property writes cell styles.
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, nombreArchivo);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    this.wrapAndCenterCell(<CellObject>worksheet.B2);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // Use XLSXStyle instead of XLSX write function which property writes cell styles.
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private wrapAndCenterCell(cell: XLSX.CellObject) {
    const wrapAndCenterCellStyle = { alignment: { wrapText: true, vertical: 'center', horizontal: 'center' } };
    this.setCellStyle(cell, wrapAndCenterCellStyle);
  }

  private setCellStyle(cell: XLSX.CellObject, style: {}) {
    cell.s = style;
  }

  public saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    //noinspection TypeScriptUnresolvedFunction
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }

}
